import React, { useState } from "react";
import "./Navbar2.css";
import logo from "../../../assets/Logo2.png";
import { FiChevronDown, FiMenu, FiX } from "react-icons/fi";

const Navbar2 = ({ onNavigate }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const handleNavClick = (section) => {
    onNavigate(section);
    setMenuOpen(false); // close menu on click
  };

  return (
    <nav className="navbar2">
      <div className="navbar2-logo">
        <img src={logo} alt="AI Shipshape Logo" />
      </div>

      <div className="navbar2-menu-icon" onClick={toggleMenu}>
        {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
      </div>

      <ul className={`navbar2-links ${menuOpen ? "open" : ""}`}>
        <li onClick={() => handleNavClick("main")}>Home</li>
        <li onClick={() => handleNavClick("about")}>About Us</li>
        <li onClick={() => handleNavClick("contact")}>Contact Us</li>
        <li className="navbar2-dropdown">
          Services <FiChevronDown size={14} />
          <ul className="navbar2-dropdown-menu">
            <li><button className="dropdown-button" onClick={() => handleNavClick('services1')}>Weather Routing and Voyage Optimization</button></li>
            <li><button className="dropdown-button" onClick={() => handleNavClick('services2')}>Vessel Optimization</button></li>
            <li><button className="dropdown-button" onClick={() => handleNavClick('services3')}>Carbon Emission Reporting</button></li>
            <li><button className="dropdown-button" onClick={() => handleNavClick('services4')}>Shipshape Chat Suite™</button></li>
          </ul>
        </li>
        {/* <li className="navbar2-dropdown">
          Upcoming <FiChevronDown size={14} />
          <ul className="navbar2-dropdown-menu">
            <li><button className="dropdown-button" onClick={() => handleNavClick('upcoming1')}>Shipshape ThrustPower™</button></li>
            <li><button className="dropdown-button" onClick={() => handleNavClick('upcoming2')}>Shipshape Engine Performance™</button></li>
            <li><button className="dropdown-button" onClick={() => handleNavClick('upcoming3')}>Shipshape Vision Mass Flow Reader™</button></li>
          </ul>
        </li> */}
        <li className="navbar2-mobile-join">
          <button className="navbar2-join" onClick={() => handleNavClick("contact")}>JOIN</button>
        </li>
      </ul>

      <button className="navbar2-join desktop-only" onClick={() => onNavigate("contact")}>JOIN</button>
    </nav>
  );
};

export default Navbar2;
